$(document).ready(function() {
      $(document).on('click','.shopify-section--multi-column .multicolumn-section1 .more-options-btn a',function(e) {
        e.preventDefault();
        console.log('yes');
          $('.shopify-section--multi-column .multicolumn-section1 .multi-column__item:nth-child(n+5)').addClass('show-hidden-item');
      $('.shopify-section--multi-column .multicolumn-section1 .more-options-btn').hide();
        $('.shopify-section--multi-column .multicolumn-section1 .less-options-btn').show();
      });
  $(document).on('click','.shopify-section--multi-column .multicolumn-section1 .less-options-btn a',function(e) {
        e.preventDefault();
          $('.shopify-section--multi-column .multicolumn-section1 .multi-column__item:nth-child(n+5)').removeClass('show-hidden-item');
      $('.shopify-section--multi-column .multicolumn-section1 .less-options-btn').hide();
    $('.shopify-section--multi-column .multicolumn-section1 .more-options-btn').show();
      });

   $(document).on('click','.shopify-section--multi-column .multicolumn-section2 .more-options-btn a',function(e) {
        e.preventDefault();
          $('.shopify-section--multi-column .multicolumn-section2 .multi-column__item:nth-child(n+5)').addClass('show-hidden-item');
      $('.shopify-section--multi-column .multicolumn-section2 .more-options-btn').hide();
        $('.shopify-section--multi-column .multicolumn-section2 .less-options-btn').show();
      });
  $(document).on('click','.shopify-section--multi-column .multicolumn-section2 .less-options-btn a',function(e) {
        e.preventDefault();
          $('.shopify-section--multi-column .multicolumn-section2 .multi-column__item:nth-child(n+5)').removeClass('show-hidden-item');
      $('.shopify-section--multi-column .multicolumn-section2 .less-options-btn').hide();
    $('.shopify-section--multi-column .multicolumn-section2 .more-options-btn').show();
      });

  $(document).on('click','.shopify-section--multi-column .multicolumn-section3 .more-options-btn a',function(e) {
        e.preventDefault();
          $('.shopify-section--multi-column .multicolumn-section3 .multi-column__item:nth-child(n+5)').addClass('show-hidden-item');
      $('.shopify-section--multi-column .multicolumn-section3 .more-options-btn').hide();
        $('.shopify-section--multi-column .multicolumn-section3 .less-options-btn').show();
      });
  $(document).on('click','.shopify-section--multi-column .multicolumn-section3 .less-options-btn a',function(e) {
        e.preventDefault();
          $('.shopify-section--multi-column .multicolumn-section3 .multi-column__item:nth-child(n+5)').removeClass('show-hidden-item');
      $('.shopify-section--multi-column .multicolumn-section3 .less-options-btn').hide();
    $('.shopify-section--multi-column .multicolumn-section3 .more-options-btn').show();
      });
    });